import { render, staticRenderFns } from "./dniRadio.vue?vue&type=template&id=2a1ca3d0&"
import script from "./dniRadio.vue?vue&type=script&lang=js&"
export * from "./dniRadio.vue?vue&type=script&lang=js&"
import style0 from "./dniRadio.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports